export default __webpack_public_path__ + "static/media/repayment-channel-icon7.5e6740f4.png";